import React from 'react';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import TextField from '@common_textfield';
import Button from '@common_button';
import InputAdornment from '@material-ui/core/InputAdornment';
import useStyles from '@modules/login/pages/default/components/style';
import Alert from '@material-ui/lab/Alert';
// import { useRouter } from 'next/router';
// import Link from 'next/link';

const Login = (props) => {
    const classes = useStyles();
    const {
        email, setEmail, password, setPassword, signInMethod,
        // storeLogo, dataConfig,
    } = props;
    // const router = useRouter();

    return (
        <div className={clsx(classes.loginContainer)}>
            <div className={classes.containLeft}>
                <div className={classes.loginContent}>
                    <form>
                        <div className="row center-xs start-sm">
                            <Typography variant="h2" className={classes.textTitle}>
                                Hello Again!
                            </Typography>
                            <Typography variant="h6" gutterBottom className={classes.textSubTitle}>
                                Welcome back! Please enter your details
                            </Typography>
                            <div className={clsx('col-xs-12 col-sm-12', classes.formField)}>
                                <TextField
                                    name="email"
                                    placeholder="Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className={classes.textInput}
                                    variant="outlined"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="start">
                                                <img alt="" src="/assets/img/email.svg" />
                                            </InputAdornment>
                                        ),
                                    }}
                                    onKeyPress={(ev) => {
                                        if (ev.key === 'Enter') {
                                            signInMethod();
                                        }
                                    }}
                                />
                            </div>
                            <div className={clsx('col-xs-12 col-sm-12', classes.formField)}>
                                <TextField
                                    name="password"
                                    placeholder="Password"
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className={classes.textInput}
                                    variant="outlined"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="start">
                                                <img alt="" src="/assets/img/lock.svg" />
                                            </InputAdornment>
                                        ),
                                    }}
                                    onKeyPress={(ev) => {
                                        if (ev.key === 'Enter') {
                                            signInMethod();
                                        }
                                    }}
                                />
                            </div>
                            <div className={clsx('col-xs-12 col-sm-12', classes.formField)}>
                                {/* <Typography variant="h6" className={classes.btnTextForgot}> */}
                                {/*     <Link href="/forgotpassword"> */}
                                {/*         <a>Forgot your password?</a> */}
                                {/*     </Link> */}
                                {/* </Typography> */}
                                <Button onClick={signInMethod} variant="contained" className={classes.btnLogin}>
                                    <span className={classes.btnLoginText}>Sign In</span>
                                </Button>
                            </div>
                        </div>
                    </form>
                </div>
                <div className={classes.infoWrapper}>
                    <Alert className="alertContainer" severity="info">
                        <Typography className="infoTitle" variant="p">Info bagi Vendor :</Typography>
                        <ul>
                            <li>
                                <Typography className="infoDesc" variant="span">
                                    Mohon periksa kembali email Anda untuk pengecekan credential login yang sudah dikirimkan sebelumnya
                                </Typography>
                            </li>
                            <li>
                                <Typography className="infoDesc" variant="span">
                                    Untuk permintaan reset pasword bisa menghubungi email andrew.listan@mitra10.com
                                </Typography>
                            </li>
                            <li>
                                <Typography className="infoDesc" variant="span">
                                    Apabila ada pertanyaan lainnya, bisa hubungi Merchandising Mitra10
                                </Typography>
                            </li>
                            <li>
                                <Typography className="infoDesc" variant="span">
                                    Demi keamanan data Anda, mohon untuk dilakukan update password saat akses pertama kali dan secara berkala
                                </Typography>
                            </li>
                        </ul>
                    </Alert>
                </div>
                <Typography variant="h6" className={classes.textFooter}>
                    Copyright © 2023 Mitra10.com. All Rights Reserved.
                </Typography>
            </div>
            <div className={classes.containRight}>
                <img alt="" src="/assets/img/mitra10_login.png" className={classes.rightImg} />
            </div>
        </div>
    );
};

export default Login;
